import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule, FormGroup, FormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GeneralService } from '../../shared/services/general.service';
import { UserService } from '../../shared/services/user.service';
import { LoadGeneralComponent } from '../../shared/components-generals/load-general/load-general.component';
import { User } from '../../shared/models/user-model/user';
import { InputGeneral } from '../../shared/inputs/input-general/input-general';

@Component({
  selector: 'app-recover-password',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatButtonModule,
    MatDialogModule,
    LoadGeneralComponent,
    InputGeneral,
  ],
  templateUrl: './recover-password.component.html',
})
export class RecoverPasswordComponent {
  userUpdate!: User;
  isLoading: boolean = false;
  public username: FormControl = new FormControl('', {
    nonNullable: true,
    validators: [Validators.required],
  });
  constructor(
    public router: Router,
    private userService: UserService,
    private generalService: GeneralService,
  ) {}

  recoverPassword() {
    this.isLoading = true;

    const recoverPasswordRequest = {
      username: this.username.value,
      isWeb: true,
    };

    this.userService.recoverPassword(recoverPasswordRequest).subscribe({
      next: () => {
        //Aqui estaba reponse
        this.isLoading = false;

        this.generalService.viewSnacAlert(
          'users.messages.recoverySent',
          'normal',
          'users.labels.success',
        );

        this.router.navigate(['/login']);
      },
      error: (error) => {
        this.isLoading = false;

        if (error.error === 'IpNotAuthorized') {
          this.generalService.viewSnacAlert(
            'errorMessages.ipNotAuthorized',
            'error',
            'users.labels.error',
          );
        } else {
          this.generalService.viewSnacAlert(
            'errorMessages.recoveryFailed',
            'error',
            'labels.error',
          );
        }
      },
    });
  }

  public getControl(formGroup: FormGroup, key: string): FormControl {
    return formGroup.get(key) as FormControl;
  }
}
